export const getEnvConfig = () => window.ENV_CONFIG;
